import { render, staticRenderFns } from "./TambahMenu.vue?vue&type=template&id=4e3a0a7f&scoped=true"
import script from "./TambahMenu.vue?vue&type=script&lang=js"
export * from "./TambahMenu.vue?vue&type=script&lang=js"
import style0 from "./TambahMenu.vue?vue&type=style&index=0&id=4e3a0a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a0a7f",
  null
  
)

export default component.exports